import {gsap} from 'gsap'

export class FadeIn {
    constructor(el, duration = 2, delay = 0) {
        this._el = el
        this._duration = duration
        this._delay = delay
        this._options = {
            threshold: 0.7 // at least x% visible
        }
        this._prepareElement()
        this._setupObserver()
    }

    _prepareElement() {
        gsap.to(this._el,
            {opacity: 0}
        )
    }

    _setupObserver() {
        this._observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(
                    (entry) => {
                        if (entry.isIntersecting /*&& document.body.classList.contains('can-animate')*/) {
                            this._observer.unobserve(this._el)
                            if (this._delay > 0) {
                                window.setTimeout(() => { this._performAnimation() }, this._delay * 1000)
                            } else {
                                this._performAnimation()
                            }
                        }
                    }
                )
            },
            this._options
        )
        this._observer.observe(this._el)
    }

    _performAnimation () {
        gsap.to(this._el,
            {duration: this._duration, opacity: 1}
        )
    }
}
